// Copyright (c) 2026 Vigeos SASU. Tous droits réservés.
/**
 * États du détecteur de chute d'un serveur, tels que les porte le rapport de
 * santé (`DetectorHealthBody`) et que `GET /api/kits` les rend dans
 * `detector.detector_state`. Mêmes libellés sur le tableau de bord, la fiche de
 * l'établissement et la liste des serveurs, dont le détail ne change que celui
 * de `unknown`.
 *
 * `crashed`, `stopped` et `disabled` sont les états cassés du backend
 * (detector_health.BROKEN_STATES). Seul `crashed` ressort en rouge : ce n'est
 * pas un choix d'exploitation mais une détection tombée seule, donc un
 * établissement qui se croit surveillé à tort.
 *
 * `disabled` est un serveur qui tourne et n'alerte personne : émission
 * d'alertes non armée (défaut d'un serveur posé par la clé, à armer sur place,
 * étape 4 bis du runbook de pose) ou aucun modèle de chute chargé. La raison
 * du serveur dit lequel.
 */
export const DETECTOR_STATES = {
  running: { label: 'Détection active', couleur: 'success' },
  crashed: { label: 'Détecteur en défaut', couleur: 'error' },
  stopped: { label: 'Détecteur arrêté', couleur: 'warning' },
  disabled: { label: 'Détection désarmée', couleur: 'warning' },
  unknown: { label: 'Aucun rapport', couleur: 'default' },
};
